<!-- 表计读数列表 -->
<template>
    <div class="container containerBox">
        <!-- 头部筛选区 -->
        <div class="handle-box">
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <el-form-item :label="$t('household.selectRes')" prop="residenceOID">
                    <cmp-build-select 
                        :buildRoom="buildRoom"
                        changeOnSelect
                        @listenBuildResult="listenBuildResult"></cmp-build-select>                   
                </el-form-item>
                <el-form-item label="序列号">
                    <el-input v-model="handleForm.deviceSerial" placeholder="请输入表计序列号"></el-input>
                </el-form-item>
                <!-- <el-form-item label="开关机">
                    <el-select v-model="handleForm.power_on" clearable placeholder="请选择">
                        <el-option label="开机" :value="1"></el-option>
                        <el-option label="关机" :value="0"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="集控器">
                    <el-select placeholder="请选择集控器" clearable v-model="handleForm.collector_id" >
                        <el-option
                            v-for="v in gatewayList"
                            :key="v.oid"
                            :label="v.dev_name"
                            :value="v.oid">
                                <span style="float: left">{{ v.dev_name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ v.device_serial }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
                <div class="fr">
                    <el-form-item>
                        <el-button type="primary" plain icon="el-icon-refresh" @click="onRefresh">刷新</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div style="margin:-15px 0 10px;">
            <!-- <el-alert class="tips-box" :closable="false" type="success" title="">
                <span class="tips-item">设备总数：{{devTip.total}}</span>&nbsp;&nbsp;
                <span class="tips-item" v-if="devTip.status>0">故障：{{devTip.status}}</span>&nbsp;&nbsp;
                <span class="tips-item" v-if="devTip.power>0">关机：{{devTip.power}}</span>
            </el-alert> -->
        </div>
      <!-- 温控器 -->
        <l-table
            :list="tableData"
            :total="total" 
            :otherHeight="260" 
            :options="options"
            :pagination="pagination"
            :columns="columns" 
            :operates="operates"
            @handleSizeChange="handleSizeChange"
            @handleIndexChange="handleIndexChange">
        </l-table>
    </div>
</template>

<script>
import Service from '@/api/Service'
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
import lTable from '@/components/lTable/lTable'
import { base64ToHex } from '@/utils/base64ToHex'
import checkPermission from '@/utils/permission'

export default {
    name: "equipmentcontrol",
    inject: ["reload"],
    data() {
        return {
            // 选择房间组件
            buildRoom: {},
            gatewayList: [],    // 集控器列表
            // 搜索参数
            handleForm: {
                deviceSerial: '',
                status: '',
                power_on: '',
                sys_status: '',
                factory_mode: '',
                fcu_in_counting: '',
                moduleid: 0,
                collector_id: '',
                is_house: false,
				buildingindex:0,
            },
            activeTable: '',
            // 数据
            tableData: [],  //  温控器列表
			roomarr:[],
             // 表格栏
            total: 0,
            pagination: {
                page_num: 1,
                page_sum: 10
            },
            columns: [
                // {
                //     prop: 'devicetype',
                //     label: '表计类型',
                //     align: 'center',
                //     formatter: (row, column, cellValue) => {
                //         return row.devicetype === 1 ? '温控器' : "风柜"
                //     }
                // },
				{
				    prop: 'devicemodel',
				    label: '表计类型',
				    align: 'center',
				},
				{
					prop: 'devicebase',
					label: '序列号',
					align: 'center',
					formatter: (row, column, cellValue) => {
					    let base = base64ToHex(row['device-serial'])
						if(row['devicemodel'] == 'FC109R'){
							return `${row['device-serial']}(${base})`
						}else{
							return `${row['device-serial']}`
						}
					    
					}
				},				
                {
                    prop: 'housename',
                    label: '安装位置',
                    align: 'center',
                },
                 {
                    prop: 'status',
                    label: '状态',
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {type: params.row.status === 1 ? 'success' : 'danger'} // 组件的props
                        }, params.row.status === 1 ? '在线' : '离线')
                    }
                },
                {
                    prop: 'power_on',
                    label: '开关机',
                    align: 'center',
                    sortable: true,
                    formatter: (row, column, cellValue) => {
                        if(row.status === 1) {
                            return row.power_on === 1 ? '开机' : "关机"
                        }else{
                            return "关机"
                        }
                    }
                },
                {
                    prop: 'speed',
                    label: '风速',
                    align: 'center', 
                    formatter: (row, column, cellValue) => {
                        switch (row.speed) {
                            case 0:
                                return "自动"
                            case 1:
                                return "高风"
                            case 2:
                                return "中风"
                            case 3:
                                return "低风"
							case 4:
							    return "允许通风"
							case 5:
							    return "禁用通风"
                            default:
                                return ''
                        }
                    }
                },
                {
                    prop: 'mode',
                    label: '模式',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        switch (row.mode) {
                            case 0:
                                return "制冷"
                            case 1:
                                return "通风"
                            case 2:
                                return "制热"
                            case 3:
                                return "自动"
							case 4:
								return "AutoHeat"
							case 5:
								return "AutoCool"
                            default:
                                return ''
                        }
                    }
                },
                {
                    prop: 'temperature',
                    label: '设置温度',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
						var str1 = JSON.stringify(row.temperature)
						var str2= row.temperatureMode === "F" ? "℉" : "℃"
                        return str1 + str2
                    }
                },
                {
                    prop: 'valve_on',
                    label: '电磁阀',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        switch (row.valve_on) {
                            case 0:
                                return "全关"
                            case 1:
                                return "热水开"
							case 2:
							    return "开启"
                            case 16:
                                return "冷水开"
                            default:
                                return ''
                        }
                    }
                },
                {
                    prop: 'key_lock',
                    label: '按键锁',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
						if(row['device-model'] == "FC226W"){
							return this.fmtKeyLock(row.key_lock)
						}else{
							switch (row.key_lock) {
								case 0:
									return "解除锁定"
								case 1:
									return "锁定开关机"
								case 2:
									return "锁定模式"
								case 3:
									return "锁定风速"
								case 4:
									return "锁定温度设置"
								case 5:
									return "锁定所有按键操作"
								default:
									return ''
							}
						}
                    }
                },
            ], // 需要展示的列
            operates: {
                width: 120,
                fixed: 'right',
                list: [
                   {
                        label: '控制设备',
                        type: 'primary',
                        show: (index, row) => {
                            return true
                        },
                        icon: '',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.toDetail(row);
                        },
                    },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false // 是否支持列表项选中功能
            }, // table 的参数

           
        };
    },
    components: { CmpBuildSelect, lTable },
    computed: { },
    created() {
        this.getReading();
        this.getList()
		this.getroom()
    },
    methods: {
		fmtKeyLock(key_lock) {
			key_lock=parseInt(key_lock)
			if(key_lock == 0){
				return "解除锁定"
			}else if(key_lock == 15){
				return "全部锁定"
			}else{
				const str = key_lock.toString(2)
				var strarr = str.split("")
				// var lockarr = ["锁定温度","锁定风速","锁定模式","锁定开关机"]
				var lockarr = ["锁定开关机","锁定模式","锁定风速","锁定温度"]
				var keylockstr = ""
				for(var i = 0 ; i < lockarr.length;i++){
					if(strarr[i] == "1"){
						keylockstr = keylockstr + " " + lockarr[i]
					}
				}
				return keylockstr
			}
		},
        // 获取表计当前读数
        async getReading() {
            let params = Object.assign({}, this.pagination, this.handleForm);
            let res = await Service.getnewTerminalcurrentreadingsbypid(params);
			
            if(res) {
                let data = res.list == null ? [] : res.list;
				let list = data
                this.total = res.total;
                this.tableData = this.fmtData(list);
				
				for(var i = 0;i<this.tableData.length;i++){
					
					if(this.tableData[i]['devicemodel'] == "FC226W"){
						//开关机
						if(list[i].data.powerStatus == "On"){
							this.tableData[i].power_on = 1
						}else{
							this.tableData[i].power_on = 0
						}
						//电磁阀
						if(list[i].data.waterValve == "On"){
							this.tableData[i].valve_on = 1
						}else{
							this.tableData[i].valve_on = 0
						}
						//风速
						if(list[i].data.fanSpeed == "Auto"){
							this.tableData[i].speed = 0
						}else if(list[i].data.fanSpeed == "High"){
							this.tableData[i].speed = 1
						}else if(list[i].data.fanSpeed == "Medium"){
							this.tableData[i].speed = 2
						}else if(list[i].data.fanSpeed == "Low"){
							this.tableData[i].speed = 3
						}else{
							this.tableData[i].speed = 4
						}
						//模式
						if(list[i].data.workMode == "COOLING" || list[i].data.workMode == "Cool"){
							this.tableData[i].mode = 0
						}else if(list[i].data.workMode == "Fan"){
							this.tableData[i].mode = 1
						}else if(list[i].data.workMode == "Heat"){
							this.tableData[i].mode = 2
						}else if(list[i].data.workMode == "Auto"){
							this.tableData[i].mode = 3
						}else if(list[i].data.workMode == "AutoHeat"){
							this.tableData[i].mode = 4
						}else if(list[i].data.workMode == "AutoCool"){
							this.tableData[i].mode = 5
						}else{
							this.tableData[i].mode = 6
						}
						//设置温度
						if(list[i].data.temperatureMode == "C"){
							this.tableData[i].temperature = (list[i].data.roomTemperatureSp)/10
							this.tableData[i].temperatureMode = list[i].data.temperatureMode
						}else{
							this.tableData[i].temperature = ((list[i].data.roomTemperatureSp / 10 * 1.8) + 32)
							this.tableData[i].temperatureMode = list[i].data.temperatureMode
						}
						
						//按键锁
						this.tableData[i].key_lock = parseInt(list[i].data.keyBoardlock)
						
					}
					if(this.tableData[i]['devicemodel'] == "FC890"){
						//电磁阀
						if(list[i].data.valve1_on == "0" && list[i].data.valve2_on == "0"){
							this.tableData[i].valve_on = 0
						}else if(list[i].data.valve1_on == "1"){
							this.tableData[i].valve_on = 16
						}else if(list[i].data.valve1_on == "1"){
							this.tableData[i].valve_on = 1
						}else{
							this.tableData[i].valve_on = 4
						}
						//风速
						if(list[i].data.setting_allow_ventilation == 0){
							this.tableData[i].speed = 5
						}else if(list[i].data.setting_allow_ventilation == 1){
							this.tableData[i].speed = 4
						}
						//开机模式
						if(list[i].data.setting_power_on == "0"){
							this.tableData[i].power_on = 0
						}else if(list[i].data.setting_power_on == "1"){
							this.tableData[i].power_on = 1
						}
						//模式
						if(list[i].data.setting_mode == "1"){
							this.tableData[i].mode = 0
						}else if(list[i].data.setting_mode == "4"){
							this.tableData[i].mode = 1
						}else if(list[i].data.setting_mode == "8"){
							this.tableData[i].mode = 2
						}else{
							this.tableData[i].mode = 6
						}
						//设置温度
						if(list[i].data.setting_mode == "1"){
							this.tableData[i].temperature = (list[i].data.setting_cooling_temperature)/10
						}else if(list[i].data.setting_mode == "8"){
							this.tableData[i].temperature = (list[i].data.setting_heating_temperature)/10
						}else{
							this.tableData[i].temperature = ""
						}
						//按键锁
						if(list[i].data.setting_key_lock == "1"){
							this.tableData[i].key_lock = 1
						}else if(list[i].data.setting_key_lock == "2"){
							this.tableData[i].key_lock = 4
						}else if(list[i].data.setting_key_lock == "4"){
							this.tableData[i].key_lock = 2
						}else if(list[i].data.setting_key_lock == "8"){
							this.tableData[i].key_lock = 3
						}else if(list[i].data.setting_key_lock == "128"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "15"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "0"){
							this.tableData[i].key_lock = 0
						}
					}
					
					
					if(this.tableData[i]['devicemodel'] == "FC810"){
						//电磁阀
						if(list[i].data.valve1_on == "0" && list[i].data.valve2_on == "0"){
							this.tableData[i].valve_on = 0
						}else if(list[i].data.valve1_on == "1"){
							this.tableData[i].valve_on = 16
						}else if(list[i].data.valve1_on == "1"){
							this.tableData[i].valve_on = 1
						}else{
							this.tableData[i].valve_on = 4
						}
						//风速
						if(list[i].data.setting_speed == "128"){
							this.tableData[i].speed = 0
						}else if(list[i].data.setting_speed == "8"){
							this.tableData[i].speed = 1
						}else if(list[i].data.setting_speed == "4"){
							this.tableData[i].speed = 2
						}else if(list[i].data.setting_speed == "2"){
							this.tableData[i].speed = 3
						}else{
							this.tableData[i].speed = 8
						}
						//模式
						if(list[i].data.setting_mode == "1"){
							this.tableData[i].mode = 0
						}else if(list[i].data.setting_mode == "4"){
							this.tableData[i].mode = 1
						}else if(list[i].data.setting_mode == "8"){
							this.tableData[i].mode = 2
						}else if(list[i].data.setting_mode == "Auto"){
							this.tableData[i].mode = 3
						}else if(list[i].data.setting_mode == "AutoHeat"){
							this.tableData[i].mode = 4
						}else if(list[i].data.setting_mode == "AutoCool"){
							this.tableData[i].mode = 5
						}else{
							this.tableData[i].mode = 6
						}
						//设置温度
						this.tableData[i].temperature = (list[i].data.setting_temperature)/10
						//模式
						if(list[i].data.setting_power_on == "0"){
							this.tableData[i].power_on = 0
						}else if(list[i].data.setting_power_on == "1"){
							this.tableData[i].power_on = 1
						}
						//按键锁
						if(list[i].data.setting_key_lock == "1"){
							this.tableData[i].key_lock = 1
						}else if(list[i].data.setting_key_lock == "2"){
							this.tableData[i].key_lock = 4
						}else if(list[i].data.setting_key_lock == "4"){
							this.tableData[i].key_lock = 2
						}else if(list[i].data.setting_key_lock == "128"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "8"){
							this.tableData[i].key_lock = 3
						}else if(list[i].data.setting_key_lock == "15"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "0"){
							this.tableData[i].key_lock = 0
						}
						
					}
					//fc900c
					if(this.tableData[i]['devicemodel'] == "FC900C"){
						//风速
						if(list[i].data.setting_speed == "128"){
							this.tableData[i].speed = 0
						}else if(list[i].data.setting_speed == "8"){
							this.tableData[i].speed = 1
						}else if(list[i].data.setting_speed == "4"){
							this.tableData[i].speed = 2
						}else if(list[i].data.setting_speed == "2"){
							this.tableData[i].speed = 3
						}else{
							this.tableData[i].speed = 8
						}
						//模式
						if(list[i].data.set_mode == "1"){
							this.tableData[i].mode = 0
						}else if(list[i].data.set_mode == "2"){
							this.tableData[i].mode = 1
						}else if(list[i].data.set_mode == "3"){
							this.tableData[i].mode = 2
						}else{
							this.tableData[i].mode = 6
						}
						//设置温度
						this.tableData[i].temperature = list[i].data.set_temp
						//模式
						if(list[i].data.power_on == "0"){
							this.tableData[i].power_on = 0
						}else if(list[i].data.power_on == "1"){
							this.tableData[i].power_on = 1
						}
						//按键锁
						if(list[i].data.key_lock == "1"){
							this.tableData[i].key_lock = 1
						}else if(list[i].data.key_lock == "2"){
							this.tableData[i].key_lock = 4
						}else if(list[i].data.key_lock == "4"){
							this.tableData[i].key_lock = 2
						}else if(list[i].data.key_lock == "8"){
							this.tableData[i].key_lock = 3
						}else if(list[i].data.key_lock == "128"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.key_lock == "15"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.key_lock == "0"){
							this.tableData[i].key_lock = 0
						}
						
					}
					//fc100ck
					if(this.tableData[i]['devicemodel'] == "FC100CKM"){
						//风速
						if(list[i].data.set_speed == "2"){
							this.tableData[i].speed = 3
						}else if(list[i].data.set_speed == "4"){
							this.tableData[i].speed = 2
						}else if(list[i].data.set_speed == "8"){
							this.tableData[i].speed = 1
						}else if(list[i].data.set_speed == "128"){
							this.tableData[i].speed = 0
						}else{
							this.tableData[i].speed = 8
						}
						//模式
						if(list[i].data.set_mode == "1"){
							this.tableData[i].mode = 0
						}else if(list[i].data.set_mode == "4"){
							this.tableData[i].mode = 1
						}else if(list[i].data.set_mode == "8"){
							this.tableData[i].mode = 2
						}else if(list[i].data.set_mode == "16"){
							this.tableData[i].mode = 3
						}else{
							this.tableData[i].mode = 6
						}
						//电磁阀
						if(list[i].data.value_status == "0"){
							this.tableData[i].valve_on = 0
						}else if(list[i].data.value_status == "1"){
							this.tableData[i].valve_on = 2
						}
						//设置温度
						this.tableData[i].temperature = list[i].data.set_temp
						//模式
						if(list[i].data.power_on == "0"){
							this.tableData[i].power_on = 0
						}else if(list[i].data.power_on == "1"){
							this.tableData[i].power_on = 1
						}
					}
					//fc100ckb
					if(this.tableData[i]['devicemodel'] == "FC100CKB"){
						//风速
						if(list[i].data.setting_speed == "2"){
							this.tableData[i].speed = 3
						}else if(list[i].data.setting_speed == "4"){
							this.tableData[i].speed = 2
						}else if(list[i].data.setting_speed == "8"){
							this.tableData[i].speed = 1
						}else if(list[i].data.setting_speed == "128"){
							this.tableData[i].speed = 0
						}else{
							this.tableData[i].speed = 8
						}
						//模式
						if(list[i].data.setting_model == "1"){
							this.tableData[i].mode = 0
						}else if(list[i].data.setting_model == "4"){
							this.tableData[i].mode = 1
						}else if(list[i].data.setting_model == "8"){
							this.tableData[i].mode = 2
						}else if(list[i].data.setting_model == "16"){
							this.tableData[i].mode = 3
						}else{
							this.tableData[i].mode = 6
						}
						//设置温度
						this.tableData[i].temperature = (list[i].data.setting_temp) / 10
						//电磁阀
						if(list[i].data.value == "0"){
							this.tableData[i].valve_on = 0
						}else if(list[i].data.value == "1"){
							this.tableData[i].valve_on = 2
						}
						//模式
						if(list[i].data.power_on == "0"){
							this.tableData[i].power_on = 0
						}else if(list[i].data.power_on == "1"){
							this.tableData[i].power_on = 1
						}
						//按键锁
						if(list[i].data.setting_key_lock == "1"){
							this.tableData[i].key_lock = 1
						}else if(list[i].data.setting_key_lock == "2"){
							this.tableData[i].key_lock = 4
						}else if(list[i].data.setting_key_lock == "4"){
							this.tableData[i].key_lock = 2
						}else if(list[i].data.setting_key_lock == "8"){
							this.tableData[i].key_lock = 3
						}else if(list[i].data.setting_key_lock == "128"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "15"){
							this.tableData[i].key_lock = 5
						}else if(list[i].data.setting_key_lock == "0"){
							this.tableData[i].key_lock = 0
						}
					}
					
				}
            }
        },
        // 获取集控器列表
        async getList() {
            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                this.gatewayList = data;
            }
        },
        fmtData(data) {
            let arr = data.map(v=>{
                let obj = {}
                obj.oid = v.terminalid;
                obj.devicetype = 1;
                obj["devicemodel"] = v["device-model"];
                obj["device-serial"] = v["device-serial"];
				// obj['devicebase'] = base64ToHex(v["device-serial"]) || "";
                obj.status = v.status;
                obj.householdname = v.householdname;
                obj.housename = v.housename;
				obj.customized_serial = v.customized_serial;
                let {
                    antifreezing, 
                    key_lock, mode, 
                    model, 
                    op_at_acback, 
                    power_on, 
                    room_temperature, 
                    speed,
                    temperature, 
                    temperature_dl, 
                    temperature_ul,
                    time_hour,
                    time_minute,
                    time_second,
                    valve_on,
                    version, } = v.data;
                    obj = Object.assign(obj,{antifreezing, key_lock, mode,model,op_at_acback,power_on,room_temperature,speed,temperature,temperature_dl,temperature_ul,time_hour,time_minute,time_second,valve_on,version, } )      
                    return obj
            })
            return arr
        },
		getroom(){
			this.$store.dispatch("GetProjectInfo").then( res => {
			    // 获取模型结构
				Service.getTemplate({oid:res.buildings_template_id}).then(ress => {
					this.roomarr = this.fmdata(JSON.parse(ress.description))
				})
			}).catch(res=>{
				
			})
		},
        // 最后一级房间确认信息
        listenBuildResult(data) {
			let typename=data.typename
            if(data.householdid === undefined) {
				this.handleForm.buildingindex=this.roomarr.filter(v=>{return v.typename == typename})[0].id + 1
                // 建筑
                this.handleForm.is_house = false
            }else{
				this.handleForm.buildingindex=this.handleForm.buildingindex + 1
                // 房间
                this.handleForm.is_house = true
            }
            this.handleForm.moduleid = data.oid || 0;
        },
		fmdata(data){
			return data.reduce((arr, { id, typename, children = [] }) =>
				arr.concat([{ id, typename }], this.fmdata(children)), [])
		},
        // 查询
        onSubmit() {
            this.getReading()
        },
        // 刷新
        onRefresh() {
            this.getReading();
        },
        // 切换页码
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getReading()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getReading()
        },
        // handleControl(row) {
        //     this.form.terminalid = row.oid
        //     this.form.controlType = row.devicetype
        //     this.dialogVisible = true;
        // },
        toDetail(row) {
            if(!checkPermission('device_control')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
			if(row["devicemodel"] =="FC226W"){
				this.$router.push('/equipmentControl1/Info1/'+ row.oid)
			}else{
				this.$router.push('/equipmentControl1/Info/'+ row.oid)
				
			}
            
        },
    }
};
</script>
<style lang='less' scoped>

</style>
